/* Sticky cart bar logic — extracted from snippets/global-cart-bar.liquid.
   window.__mburMoneyFormat is set inline by the snippet (Liquid value).
   Defer-safe: reads DOM + /cart.js after load; consumers (chat tab) act on
   click, after deferred scripts have run. */
(function() {
  var bar = document.getElementById('globalCartBar');
  if (!bar) return;

  // "Help" tab opens the live chat
  var chatTab = bar.querySelector('.js-cart-bar-chat');
  if (chatTab) {
    chatTab.addEventListener('click', function () {
      if (window.MburChat && window.MburChat.open) {
        window.MburChat.open();
        return;
      }
      var trigger = document.getElementById('mbur-chat-trigger');
      if (trigger) trigger.click();
    });
  }

  var countEl = bar.querySelector('[data-cart-count-text]');
  var totalEl = bar.querySelector('[data-cart-total]');
  var moneyFormat = window.__mburMoneyFormat;

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var match = (moneyFormat || '${{amount}}').match(placeholder);
    var key = match ? match[1] : 'amount';
    switch (key) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return (moneyFormat || '${{amount}}').replace(placeholder, value);
  }

  // Move the chat button into the bar only when the bar is actually on screen
  function syncChat() {
    var active = bar.classList.contains('is-visible') && !bar.classList.contains('is-suppressed');
    document.body.classList.toggle('has-cart-bar', active);
  }
  function show() {
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
    syncChat();
  }
  function hide() {
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
    syncChat();
  }
  function pulse() {
    bar.classList.remove('global-cart-bar--pop');
    void bar.offsetWidth;
    bar.classList.add('global-cart-bar--pop');
  }

  function render(cart, pop) {
    if (!cart) return;
    var count = cart.item_count || 0;
    if (count > 0) {
      countEl.textContent = count + (count === 1 ? ' item' : ' items');
      totalEl.textContent = formatMoney(cart.total_price);
      show();
      if (pop) pulse();
    } else {
      hide();
    }
  }

  function refresh(pop) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) { render(cart, pop); })
      .catch(function() {});
  }

  // Initial state — show if the cart already has items
  refresh(false);

  // Watch all cart mutations (works no matter which code adds to cart)
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var input = args[0];
      var url = (input && input.url) ? input.url : input;
      return origFetch.apply(this, args).then(function(resp) {
        try {
          if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
            setTimeout(function() { refresh(true); }, 150);
          }
        } catch (e) {}
        return resp;
      });
    };
  }

  // Bonus: themes/sections that dispatch this event
  document.addEventListener('cart:item-added', function() { refresh(true); });

  // Hide the bar while the cart drawer is open
  var drawer = document.querySelector('.js-cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function() {
      if (drawer.classList.contains('is-open')) {
        bar.classList.add('is-suppressed');
      } else {
        bar.classList.remove('is-suppressed');
      }
      syncChat();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
})();
